"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M10.82,15.69V2.49a2.49,2.49,0,0,0-5,0h0v13.2a4.53,4.53,0,1,0,5,0ZM8.33,20.91A1.51,1.51,0,0,1,7.83,18V7.42a.5.5,0,0,1,1,0V18a1.51,1.51,0,0,1-.5,2.9Z"
  }), /*#__PURE__*/_react["default"].createElement("circle", {
    cx: "18.35",
    cy: "2.43",
    r: "0.29"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M16.78,0A3.43,3.43,0,1,0,20.2,3.44,3.43,3.43,0,0,0,16.78,0Zm.74,5.3a2.14,2.14,0,1,1,0-3.77.29.29,0,0,1-.26.51,1.51,1.51,0,1,0,0,2.78.29.29,0,0,1,.27.5ZM18.35,3a.57.57,0,1,1,.57-.57h0A.57.57,0,0,1,18.35,3Z"
  }));
};

exports["default"] = _default;